import React from "react";

export function DangerToast({message, title, subtitile, closeCallback}) {

    return (
        <div className="toast bg-danger fade show" role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header"><strong className="mr-auto">{title}</strong><small>{subtitile}</small>
                <button type="button" className="ml-2 mb-1 close" aria-label="Close" onClick={closeCallback}><span
                    aria-hidden="true">×</span></button>
            </div>
            <div className="toast-body">{message}</div>
        </div>
    )
}